import { useInfiniteQuery } from '@tanstack/vue-query';
import { computed, ref } from 'vue';
import { searchRolePermissions } from '@infuse/api/iam/role';
import { Permission } from '@infuse/api/iam/permission';
import { Pageable } from '@infuse/api/common';

export const useRolePermissions = () => {
  const fetchRoleId = ref<string | undefined>(undefined);
  const fetchSubscriptionId = ref<string | undefined>(undefined);
  const pageSize = 99999;

  const query = useInfiniteQuery<Pageable<Permission>>({
    initialPageParam: 0,
    queryKey: ['role-permissions', fetchRoleId],
    enabled: () => !!fetchRoleId.value,
    queryFn: async ({ pageParam }) => {
      const apiResponse = await searchRolePermissions(
        {
          size: pageSize,
          page: Number.parseInt(`${pageParam}`),
          sort: [{ key: 'name' }]
        },
        undefined,
        { roleId: fetchRoleId.value ?? '' }
      );

      return apiResponse;
    },
    getNextPageParam: (lastPage) => (lastPage.last ? undefined : lastPage.pageable.pageNumber + 1)
  });

  const permissions = computed(() => query.data.value?.pages.flatMap((page) => page.content) || []);

  return {
    ...query,
    fetchRoleId,
    fetchSubscriptionId,
    permissions
  };
};
